import moment from 'moment';
import 'moment-timezone';

import timeZoneMapping from '@/data/timezone-mapping';

export default class DateTimeService {

  /** @ngInject **/
  constructor(
  ) {
  }

  getCurrentMomentInTimeZone(timeZoneId) {
    if (timeZoneId) {
      const timezoneMapped = this.getTimeZoneMapping(timeZoneId);
      return moment(moment().tz(timezoneMapped).format('YYYY-MM-DD[T]HH:mm:ss'));
    }
    return moment();
  }

  getTimeZoneForBackend(timezone) {
    for(const key in timeZoneMapping) {
      if (this.getTimeZoneMapping(key) === timezone) {
        return key;
      }
    }
  }

  getTimeZoneMapping(timeZoneId) {
    return timeZoneMapping[timeZoneId] || '';
  }
}